import {
  GET_BOOKINGS,
  GET_BOOKINGS_ERROR,
} from "../constants/TimeslotsConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const getTimeslots = (date) => (dispatch) => {
  Axios.get(`${API_ROOT}/bookings?date=${date}`, config)
    .then((response) =>
      dispatch({ type: GET_BOOKINGS, payload: response.data })
    )
    .catch((error) => dispatch({ type: GET_BOOKINGS_ERROR, payload: error }));
};
